import React, {AnchorHTMLAttributes} from "react"
import Icon from "../Icon/Icon"
import classNames from "classnames"
import {IcomoonIconName} from "../Icon/icons"

interface IdLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	href: string
	icon?: IcomoonIconName
	children: React.ReactNode
}

export default function IdLink({
	icon = "maximize-square-4--interface-essential",
	children,
	className,
	href,
	target = "_blank",
	onClick,
	...props
}: IdLinkProps) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()
		e.stopPropagation()
		onClick?.(e)
		window.open(href, "_blank")
	}

	return (
		<a className={classNames("id-link", className)} href={href} target={target} onClick={handleClick} {...props}>
			{children}
			<Icon className="icon" size={12} icon={icon} />
		</a>
	)
}
